import { K5U } from "./types";

export const useK5u = (): Partial<K5U> => {
  const { k5u } = localStorage;
  if (!k5u) return {};
  try {
    return JSON.parse(k5u);
  } catch {
    return {};
  }
};

export const hypenate = (str: string): string =>
  str.replace(/(\d{3})(\d{3})/, "$1-$2");
